export default __webpack_public_path__ + "18b2db11022c64c7e267b236b7068c5d.jpg";